import React, { useContext, useState } from 'react'
import { Dropdown, Nav, Navbar } from 'react-bootstrap'
import { AuthContext } from '../auth/authProvider.jsx'
import Logo from '../../assets/img/brand/explore-w-logo-blue-large@2x.png'
import { AppContext } from '../../context'
import CustomModal from './CustomModal'

interface ToggleProps {
  children: any
  onClick: any
}

interface NavbarProps {
  children: React.ReactElement | React.ReactElement[]
}

const CustomNav = ({ children }: NavbarProps) => (
  <nav className="navbar navbar-expand-md bg-white">{children}</nav>
)

const CustomToggle = React.forwardRef(
  ({ children, onClick }: ToggleProps, ref) => (
    <a
      className="books-nav-item-link dropdown-toggle"
      href="#"
      id="navbarDropdown"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      onClick={e => {
        e.preventDefault()
        onClick(e)
      }}
    >
      {children}
    </a>
  )
)

const CustomNavbar: React.FC = () => {
  const authContext = useContext(AuthContext)
  const { userSubscriptionStatus, isUserLoaded, isAuthenticated } =
    useContext(AppContext)
  const hasToken = authContext.getAccessToken()
  const [show, setShow] = useState(false)
  const isSubscribed = userSubscriptionStatus?.hasSubscription
  const baseSubscriptionsUrl = process.env.REACT_APP_SUBSCRIPTIONS_URL
  const booksSubscriptionUrl = `${baseSubscriptionsUrl}booksSubscriptions/`
  const userSubscriptionsUrl = `${baseSubscriptionsUrl}booksSubscriptions/userSubscriptions`

  const version = process.env.REACT_APP_VERSION
  const exploreUrl = process.env.REACT_APP_EXPLORE_URL
  const profileUrl = '/edit-profile/'
  const termsAndConditionsUrl =
    'https://imray.com/digital/explore/explore-terms-and-conditions/'
  const privacyPolicyUrl =
    'https://imray.com/digital/explore/explore-privacy-policy/'

  return (
    <>
      <CustomModal
        onConfirm={() => authContext.logout()}
        title="Logging Out..."
        description="Are you sure you want to proceed logging out?"
        show={show}
        setShow={setShow}
      />
      <Navbar as={CustomNav}>
        <a className="" href={exploreUrl}>
          <img
            src={Logo}
            className="d-inline-block mapboxgl-ctrl-imray-logo"
            alt=""
            loading="lazy"
          />
        </a>
        <Navbar.Toggle label="Toggle navigation">
          <span className="material-icons">more_vert</span>
        </Navbar.Toggle>

        <Navbar.Collapse id="navbarNav">
          <Nav id="books-navbar-nav" className="navbar-nav">
            {!isSubscribed && isUserLoaded && (
              <>
                <li className="books-nav-item nav-item hide-mobile">
                  <a
                    className="books-nav-item-link"
                    href={booksSubscriptionUrl}
                  >
                    Join
                  </a>
                </li>
                {/* hidden on lg tablet and desktop devices, visible on mobiles and small tablets */}
                <li className="books-nav-item nav-item show-mobile">
                  <a
                    className="books-nav-item-link"
                    href={booksSubscriptionUrl}
                  >
                    Join
                  </a>
                </li>
              </>
            )}
            {isSubscribed && (
              <li className="books-nav-item nav-item show-mobile">
                <a className="books-nav-item-link" href={userSubscriptionsUrl}>
                  My Membership
                </a>
              </li>
            )}
            <li className="books-nav-item nav-item show-mobile">
              <a className="books-nav-item-link" href={profileUrl}>
                My Profile
              </a>
            </li>
            {/* <li className="books-nav-item nav-item show-mobile">
                <a className="books-nav-item-link" href={redeemVoucherUrl}>Redeem a Voucher</a>
            </li> */}
            <li className="books-nav-item nav-item show-mobile">
              <a className="books-nav-item-link" href={privacyPolicyUrl}>
                Privacy Policy
              </a>
            </li>
            <li className="books-nav-item nav-item show-mobile">
              <a className="books-nav-item-link" href={termsAndConditionsUrl}>
                Terms and Conditions
              </a>
            </li>
            <li className="books-nav-item nav-item show-mobile">
              <a
                className="books-nav-item-link"
                href="https://share.hsforms.com/1P4Ai829-RIyxdDcwaTJ54g4udgz"
                target="_blank"
              >
                Share your feedback
              </a>
            </li>
            {hasToken && (
              <li
                onClick={() => setShow(true)}
                className="books-nav-item nav-item show-mobile"
              >
                <div id="books-loggedin" className="books-nav-item-link">
                  Logout
                </div>
              </li>
            )}

            <li className="books-nav-item nav-item show-mobile">
              <span className="books-nav-dropdown-item">
                Version: {version}
              </span>
            </li>

            {/* Visible on desktop and lg tablets */}
            <li className="books-nav-item nav-item hide-mobile">
              <a
                className="books-nav-dropdown-item books-nav-item-link"
                href="https://share.hsforms.com/1P4Ai829-RIyxdDcwaTJ54g4udgz"
                target="_blank"
              >
                Feedback and Support
              </a>
            </li>
            <Dropdown className="books-nav-item nav-item dropdown hide-mobile">
              <Dropdown.Toggle as={CustomToggle}>
                My Account&nbsp;
              </Dropdown.Toggle>
              <Dropdown.Menu
                className="books-nav-dropdown-menu dropdown-menu dropdown-menu-right"
                aria-labelledby="navbarDropdown"
              >
                {isSubscribed && (
                  <Dropdown.Item
                    className="books-nav-dropdown-item dropdown-item"
                    href={userSubscriptionsUrl}
                  >
                    My Membership
                  </Dropdown.Item>
                )}
                <Dropdown.Item
                  className="books-nav-dropdown-item dropdown-item"
                  href={profileUrl}
                >
                  My Profile
                </Dropdown.Item>
                {/* <Dropdown.Item
                className="books-nav-dropdown-item dropdown-item"
                target="_blank"
                href={redeemVoucherUrl}
              >
                Redeem a Voucher
              </Dropdown.Item> */}
                <Dropdown.Item
                  className="books-nav-dropdown-item dropdown-item"
                  target="_blank"
                  href={privacyPolicyUrl}
                >
                  Privacy Policy
                </Dropdown.Item>
                <Dropdown.Item
                  className="books-nav-dropdown-item dropdown-item"
                  target="_blank"
                  href={termsAndConditionsUrl}
                >
                  Terms and Conditions
                </Dropdown.Item>
                <Dropdown.Item
                  className="books-nav-dropdown-item dropdown-item"
                  href="https://share.hsforms.com/1P4Ai829-RIyxdDcwaTJ54g4udgz"
                  target="_blank"
                >
                  Share your feedback
                </Dropdown.Item>
                {isAuthenticated && (
                  <Dropdown.Item
                    onClick={() => setShow(true)}
                    id="books-loggedin"
                    className="books-nav-dropdown-item dropdown-item"
                  >
                    Logout
                  </Dropdown.Item>
                )}
                <span className="books-nav-dropdown-item dropdown-item">
                  Version: {version}
                </span>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  )
}

export default CustomNavbar
